import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ServiceDetails from '../components/ServiceDetails';

const Services = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(null);
  
  // Get the tab parameter from URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    if (tab) {
      setActiveTab(tab);
    }
  }, [location]);

  return (
    <main className="min-h-screen">
      <ServiceDetails activeTab={activeTab} />
    </main>
  );
};

export default Services;
